import { getLocationUrl } from 'Helpers/url';

const useBackButtonHandling = ({ router, location, overlayHash }) => {
    const isOpened = location.hash.includes(overlayHash);

    const openModal = () => {
        const locationUrl = getLocationUrl(location);
        const updatedUrl = locationUrl.includes(overlayHash) ? locationUrl : `${locationUrl}${overlayHash}`;

        router.push(updatedUrl);
    };

    const closeModal = () => {
        let locationUrl = getLocationUrl(location);

        if (location.hash.includes(overlayHash)) {
            locationUrl = locationUrl.split('#')[0];
            router.replace(locationUrl);
        }
    };

    const removeHash = () => {
        let locationUrl = getLocationUrl(location);

        if (location.hash.includes(overlayHash)) {
            locationUrl = locationUrl.split('#')[0];
            router.replace(locationUrl);
        }
    };

    return {
        isOpened,
        openModal,
        closeModal,
        removeHash
    };
};

export default useBackButtonHandling;
